module.exports = __webpack_public_path__ + "media/metal_sheet_2.6f0d87ae.mp3";